module.exports = __webpack_public_path__ + "static/Montserrat-Regular-hint-all-119980964b7c6c0d8d0a678daa3757bd.woff2";